/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import Queue from '../queue/queue';

/**
 * @import { FileTransferDownloadResult, FileTransferManager } from "../file/transfer"
 * @import FileSystemPath from '../file/system/file-system-path'
 */

export default class Downloader {
  /**
   * @param {FileTransferManager} fileTransferManager
   */
  constructor(fileTransferManager) {
    this.fileTransferManager = fileTransferManager;
    this.downloadQueue = new Queue();
  }

  /**
   * Stáhne soubor.
   * @see {@link FileTransferManager}
   * @param {FileSystemPath} filePhysicalPath Fyzická cesta souboru do které má být soubor stažen.
   * @param {Request | string} input
   * @param {RequestInit} [init]
   * @returns {Promise<FileTransferDownloadResult>}
   */
  async download(filePhysicalPath, input, init) {
    return await this.downloadQueue.enqueue(() =>
      this.fileTransferManager.download(filePhysicalPath, input, init)
    );
  }

  /**
   * Vyčistí frontu, tj. uvede ji do stavu jako po vytvoření. Případné čekající
   * úlohy zruší s odmítnutím {@link DOMException} s name `AbortError`.
   */
  clear() {
    this.downloadQueue.clear();
  }
}
